import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelayRed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6 5.2C14.95 6.4 15.75 8.05 15.75 9.95",
			stroke: "#FF1744",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.35 3.7C17.2 5.3 18.25 7.5 18.25 9.95",
			stroke: "#FF1744",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			opacity: .45
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.75,
			cy: 10.25,
			r: 6.5,
			fill: "#FF1744"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.75,
			cy: 10.25,
			r: 5.25,
			stroke: "white",
			strokeWidth: .85,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 7.75V10.25H10.85",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDelayRed);
export { ForwardRef as ReactComponent };
